import { render, staticRenderFns } from "./DicTagButton.vue?vue&type=template&id=5ed33adc&scoped=true&"
import script from "./DicTagButton.vue?vue&type=script&lang=js&"
export * from "./DicTagButton.vue?vue&type=script&lang=js&"
import style0 from "./DicTagButton.vue?vue&type=style&index=0&id=5ed33adc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed33adc",
  null
  
)

export default component.exports